import { useBookingStateContext } from "hooks/use-booking-state";
import { useMemo } from "react";
import { TimeSlot } from "types/time-slot";
import { getBookableTimes, getWaitListTimes } from "utils/time-slot-filters";

/**
 * Hook that filters time slots based on bookability and waitlistability
 * @param times The time slots to filter
 * @returns Bookable and waitlistable time slots
 */
function useTimeSlotFilters(times: TimeSlot[]) {
    const { guests, isBookingRequest } = useBookingStateContext();

    const bookableTimes = useMemo(() => {
        // If in booking request mode, all times are bookable
        if (isBookingRequest) return times;
        return getBookableTimes(times, guests ?? 0);
    }, [times, guests, isBookingRequest]);

    const waitListTimes = useMemo(() => {
        return getWaitListTimes(times, guests ?? 0);
    }, [times, guests]);

    return { bookableTimes, waitListTimes };
}

export { useTimeSlotFilters };
